'use client';

import { Html } from '@react-three/drei';
import { useState } from 'react';

export interface HotspotData {
  id: string;
  position: [number, number, number];
  label: string;
  description?: string;
}

export interface HotspotProps {
  hotspot: HotspotData;
  dark?: boolean;
}

export function Hotspot({ hotspot, dark }: HotspotProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Html position={hotspot.position} center distanceFactor={5} zIndexRange={[10, 0]}>
      <div className="relative flex flex-col items-center select-none" style={{ pointerEvents: 'auto' }}>
        <button
          onClick={() => setExpanded((p) => !p)}
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            border: `2px solid ${dark ? '#fff' : '#18181b'}`,
            background: dark ? 'rgba(24,24,27,0.8)' : 'rgba(255,255,255,0.9)',
            color: dark ? '#fff' : '#18181b',
            fontSize: 11,
            fontWeight: 700,
            cursor: 'pointer',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.15s',
            transform: expanded ? 'scale(1.15)' : 'scale(1)',
          }}
          title={hotspot.label}
        >
          +
        </button>
        {expanded && (
          <div
            style={{
              position: 'absolute',
              top: 30,
              minWidth: 160,
              maxWidth: 220,
              background: dark ? 'rgba(24,24,27,0.95)' : 'rgba(255,255,255,0.97)',
              border: `1px solid ${dark ? '#3f3f46' : '#e4e4e7'}`,
              borderRadius: 8,
              padding: '8px 12px',
              backdropFilter: 'blur(8px)',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 600, color: dark ? '#fafafa' : '#18181b', marginBottom: 2 }}>
              {hotspot.label}
            </div>
            {hotspot.description && (
              <div style={{ fontSize: 11, color: dark ? '#a1a1aa' : '#71717a', lineHeight: '1.4' }}>
                {hotspot.description}
              </div>
            )}
          </div>
        )}
      </div>
    </Html>
  );
}
